import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const DefaultPricing = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${Colors.GS600};
  letter-spacing: 0.14px;
`

export const InputContainer = styled.div`
  padding: 8px 0px;
`

export const Suggestion = styled.div`
  color: ${Colors.GS600};
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.14px;
`

export const CurrenciesManageLinkContainer = styled.div`
  font-size: 14px;
`
